import { pipe, converge, zip, pluck, identity, map } from 'ramda'
import { OrderedMap, Map, fromJS } from 'immutable'

/**
 * This utility function takes arrays and converts them to
 * Immutable OrderedMaps so that we can store them in Redux
 * as immutable objects.
 * @param {string} | prop from array you'd like the value
 * the ordered map to use
 * @returns {OrderedMap}
 */
export default prop =>
  pipe(
    converge(zip, [pluck(prop), identity]),
    map(([k, v]) => [String(k), Map(fromJS(v))]),
    OrderedMap,
  )
